import { Component, h } from '@stencil/core';

@Component({
  tag: 'cwru-footer-links',
  styleUrl: 'footer.css',
  shadow: true,
})
export class FooterLinks {

  render() {
    return (
      <div class="footer__block footer-links">
        <h3 class="footer-header">CWRU Links</h3>
          <ul role="menu">
            <li role="menuitem">
              <a href="https://case.edu/admissions/">Apply to CWRU</a>
            </li>
            <li role="menuitem">
              <a href="https://case.edu/give/">Give Now</a>
            </li>
            <li role="menuitem">
              <a href="https://case.edu/visit/">Visit Campus</a>
            </li>
            <li role="menuitem">
              <a href="https://webapps.case.edu/directory/">University Directory</a>
            </li>
          </ul>
      </div>
    );
  }
}
